import { CommonModule } from '@angular/common';
import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { LoginSettingsService, ProfileService } from '@barthauer/abc/core/authentication';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { _AbcDashboardComponent } from '@barthauer/abc/ui-components';
import { environment } from '../../../environments/environment.prod';
import { DataService } from '../services/data.service';
import { NotificationService } from '../services/notification.service';
import { ToastType } from '../models/enumeration-list.model';

@Component({
  selector: 'ubt-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [CommonModule, _AbcDashboardComponent],
  standalone: true,
})
export class DashboardComponent implements OnInit {
  public dashboardId: string;
  public isDashboard: boolean;
  public dashboardEndpoint: string;
  public dashboardAjaxHeader: IAjaxHeader;
  public title: string;

  constructor(
    private dataService: DataService,
    private configService: AbcConfigService,
    private profileService: ProfileService,
    private loginSettingsService: LoginSettingsService,
    private noticationService:NotificationService
  ) {
    this.title = this.dataService.res('Ubt-Dashboard-No-Data');
  }
  
  async ngOnInit(): Promise<void> {
    try {
      const currentLanguage = sessionStorage.getItem('fixedCulture');
      this.dashboardId = currentLanguage === 'de' ? environment.dashboardId_De : environment.dashboardId_En;
      const profileSettings = await this.profileService.getCurrentProfile().toPromise();
      const loginSettings = await this.loginSettingsService.getCurrentLoginSettings().toPromise();
      this.dashboardEndpoint = this.configService.getConfiguration().WebApi.ServiceURLs.Dashboard;
      this.dashboardAjaxHeader = {
        Authorization: loginSettings.token_type + ' ' + loginSettings.access_token,
        ProfileId: profileSettings.id,
        P$CompanyId: localStorage.getItem('currentCompany'),
        P$ProjectId: localStorage.getItem('projectId'),
      };
      this.isDashboard = true;
    } catch (error) {
      console.error(error);
      this.isDashboard = false;
    }
  }
}

interface IAjaxHeader {
  Authorization: string;
  ProfileId: string;
  P$CompanyId: string;
  P$ProjectId: string;
}
